<template>
  <div class="banner">
    <div v-if="bgimage" class="bg" v-bind:style="{ backgroundImage: 'url(' + bgimage + ')' }">
    </div>
    <div v-else-if="bgvideo" class="bgvideo">
      <video class="bgvideo" autoplay playsinline muted loop ref="video">
        <source :src="bgvideo" type="video/mp4">
      </video>
    </div>
    <div v-else>
      <div class="text">
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
    
    <div class="text">
      <slot></slot>
    </div>
    <div class="scroller" v-on:click="scrollToContent">
      <div class="line">
      </div>
      <div v-html="$t('banner.scroll')"></div>
    </div>
    <div v-if="afterscroller" v-bind:html="afterscroller">
      <div class="text_scroll" v-bind:style="{ backgroundImage: 'url(' + afterscroller + '' }">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Banner',
  props: {
    title: String,
    bgimage: String,
    bgvideo: String,
    afterscroller: String,
    pageable: {},
    bus: {}
  },
  components: {
  },
  methods: {
    scrollToContent() {
      this.pageable.moveSectionDown();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.video) {
        this.$refs.video.play()
        this.bus.$on('pagechange', data => {
          if (data == this.$el) {
            this.$refs.video.play()
          } else {
            this.$refs.video.pause()
          }
        })
      }
      
    })
  }
}
</script>

<style scoped lang="scss">

.bg {
  background-size: cover;
}
.banner {
  text-align: center;
  position: relative;
  overflow: hidden;
  > .scroller,
  > .text,
  > .title {
    position: relative;
    z-index: 3;
  }
  &:before {
    content: '';
    position: absolute;
    pointer-events: none;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
  }
}
.bgvideo {
  position: absolute;
  height: 100%;
  width: 100%;
  video {
    min-width: 100%; 
    min-height: 100%; 
    
    /* Setting width & height to auto prevents the browser from stretching or squishing the video */
    width: auto;
    height: auto;
    
    /* Center the video */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    z-index: 1;
  }
  > div {
    position: relative;
    z-index: 3;
  }
}

.text {
  flex-grow: 1;
  flex-direction: column;
  display: flex;
  @include media-breakpoint-down(md) {
    padding-top: 30px;
  }
  @include media-breakpoint-up(lg) {
    padding-top: 50px;
  }
  padding-left: 30px;
  padding-right: 30px;
  .title {
    @include media-breakpoint-down(md) {
      margin-top: 8vh;
    }
    @include media-breakpoint-up(lg) {
      margin-top: 15vh;
    }
  }
}

.scroller {
  position: relative;
  z-index: 11;
  overflow: hidden;
  cursor: pointer;
  color: $red;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 14px;
  margin-bottom: 120px;
  font-family: $headings-font-family;


  justify-content: flex-end;
  display: flex;
  flex-direction: column;

  display: none;
  @media (min-height: 800px) {
    display: block
  }
  .line {
    position: relative;
    display: block;
    overflow: hidden;
    width: 1px;
    height: 60px;
    left: calc(50% - 1px);
    top: 0;
    margin-bottom: 10px;
    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: $light-gray;
      animation: linemove 3s ease-in-out infinite;
      @at-root {
        @keyframes linemove {
          from {transform: translateY(-105%);}
          to {transform: translateY(105%);}
        }
      }
    }
  }

}


.text_scroll {
  background-repeat: repeat-x;
  height: 40px;
  width: 100%;
  position: absolute;    
  bottom: 20px;
  z-index: 2;
  animation: textscroll 20s infinite linear;
  will-change: background-position;
  background-size: auto 90%;
  margin-right: 40px;
  @include media-breakpoint-down(md) {
    animation-duration: 80s;
    background-size: auto 82%;
  }
  @at-root {
    @keyframes textscroll {
      from{ background-position: -200% 0;}
      to{ background-position: 200% 0;}
    }
  }
}


</style>

